import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const ENERGY_DOMAIN_INTRO = {
  title: "Energy & Utilities",
  content: "Agentic AI workflow automation for Energy & Utilities — across Water Utility and related operations. Use cases span field service dispatch optimization with governed workflow automation, human review, and audit evidence. Practical deployments for utilities in India, UAE, KSA, UK, and USA.",
  seoDescription: "Energy utilities agentic AI use cases — water utility field service dispatch optimization. SCADA GIS CRM ERP field service management integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const ENERGY_SYSTEMS = "SCADA, GIS, CRM, ERP, Field Service Management, Email, Power BI";

const RAW = [
  {
    id: "field-service-dispatch-optimization",
    subIndustry: "Water Utility",
    department: "Field Service",
    businessProcess: "Field service dispatch optimization",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Field service dispatch optimization",
    title: "Field Service Dispatch Optimization Automation for Energy & Utilities",
    seoKeywords: "energy & utilities, field service dispatch optimization, AI automation, RPA, agentic AI",
    challenge: "Dispatchers manually assign leak, meter and service jobs using spreadsheets and calls.",
    solution: "Implement AI Agent + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Water Utility teams can improve field service dispatch optimization with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "AI Agent + Workflow Automation",
    buyerPersona: "Field Operations Head",
    systems: ENERGY_SYSTEMS,
    agentsRequired: "Field AI Agent, Validation Agent, Human Review Agent",
    inputData: "Emails, forms, system records, task notes, master data and field service dispatch optimization process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for field service dispatch optimization",
    keyBenefits: "Faster Response, Lower Service Workload, Better Customer Experience And Improved Sla Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const ENERGY_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Water Utility"];
export const ENERGY_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => ENERGY_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'energy-domain', domainIntro: ENERGY_DOMAIN_INTRO, useCases: ENERGY_USE_CASES });
export const ENERGY_USE_CASES_SEO = seo.useCasesSeo;
export const ENERGY_DOMAIN_FAQS = seo.domainFaqs;
export const ENERGY_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const ENERGY_FAQ_JSONLD = seo.faqJsonLd;
export const ENERGY_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const ENERGY_WEBPAGE_JSONLD = seo.webPageJsonLd;

